import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { createKPIDefinitionAction, modifyKPIDefinitionAction } from "../../actions";
import { TextField, Grid, Select, MenuItem, FormControl, InputLabel, Button } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import useHandleForm from "./useHandleForm";
import { getActiveTypes, getKPITypes, getRoleTypes } from "../../selectors";
import { AddIcon } from "@icarius-icons";
import { getAppColor } from "@icarius-app/selectors";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { dateLocale } from "@icarius-localization/strings";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";
import CustomNumberFormat from "@icarius-common/dynamicInputs/customNumberFormat";

const gridStyle = { height: 75, padding: "0px 10px" };

const SelectorButton = ({ text, onClick }) => {
    const color = useSelector(getAppColor);

    return (
        <Button style={{ margin: 5 }} variant={"outlined"} disableRipple={true} onClick={onClick}>
            <AddIcon htmlColor={color} />
            {text}
        </Button>
    );
};

const QueryForm = (props) => {
    const { data, handleClose } = props;
    const dispatch = useDispatch();

    const activeTypes = useSelector(getActiveTypes);
    const roleTypes = useSelector(getRoleTypes);
    const kpiTypes = useSelector(getKPITypes);

    const create = (formData) => {
        dispatch(createKPIDefinitionAction(formData)).then((res) => res?.status === 200 && handleClose());
    };

    const modify = (formData) => {
        dispatch(modifyKPIDefinitionAction(formData)).then((res) => res?.status === 200 && handleClose());
    };

    const openValidationError = () => {
        dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
    };

    const openSelectorValidationError = () => {
        dispatch(
            openSnackbarAction({ msg: getLocalizedString("invalidSelectors"), severity: "error", duration: 10000 })
        );
    };

    const { isCreate, formData, setFormValue, submit } = useHandleForm(
        data,
        create,
        modify,
        openValidationError,
        openSelectorValidationError
    );

    const isGraphicType = ["GH", "GV", "GP", "GO", "GR", "GL"].includes(formData.kpiType);
    const isDetailedGraphicType = ["GH", "GV", "GP", "GL"].includes(formData.kpiType);
    const isClockType = "CK" === formData.kpiType;
    const isBoxType = "BX" === formData.kpiType;

    return (
        <Grid container item xs={12} direction="row" style={{ width: "95%", margin: "auto" }}>
            <Grid container item xs={12}>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* codigo */}
                    <TextField
                        disabled={!Boolean(isCreate)}
                        required
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("kpiCode")}
                        onChange={(e) => setFormValue(e.target.value, "code")}
                        value={formData.code}
                        inputProps={{ maxLength: 10 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* nombre */}
                    <TextField
                        required
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("name")}
                        value={formData.name}
                        onChange={(e) => setFormValue(e.target.value, "name")}
                        inputProps={{ maxLength: 60 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* Activa */}
                    <FormControl style={{ width: "100%" }}>
                        <InputLabel required id={`label-active`}>
                            {getLocalizedString("activeFemale")}
                        </InputLabel>
                        <Select
                            value={formData.active}
                            labelId={`label-active`}
                            id={`select-active`}
                            onChange={(e) => setFormValue(e.target.value, "active")}
                            margin={"none"}
                        >
                            {activeTypes &&
                                activeTypes.map((item) => (
                                    <MenuItem className={"whiteText"} key={item.key} value={item.key}>
                                        {item.value}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* group */}
                    <TextField
                        required
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("locationGroup")}
                        value={formData.group}
                        onChange={(e) => setFormValue(e.target.value, "group")}
                        inputProps={{ maxLength: 100 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* secuencia */}
                    <TextField
                        required
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("appearanceSequence")}
                        InputProps={{ inputComponent: CustomNumberFormat }}
                        value={formData.sequence}
                        onChange={(e) => setFormValue(e.target.value, "sequence")}
                        inputProps={{
                            min: 1,
                            max: 999,
                            maxLength: 3,
                            isAllowed: (v) => v.floatValue === undefined || v.floatValue <= 999,
                        }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* kpi type */}
                    <FormControl style={{ width: "100%" }}>
                        <InputLabel required id={`label-kpiType`}>
                            {getLocalizedString("kpiType")}
                        </InputLabel>
                        <Select
                            value={formData.kpiType}
                            labelId={`label-kpiType`}
                            id={`select-kpiType`}
                            onChange={(e) => setFormValue(e.target.value, "kpiType")}
                            margin={"none"}
                        >
                            {kpiTypes &&
                                kpiTypes.map((item) => (
                                    <MenuItem className={"whiteText"} key={item.key} value={item.key}>
                                        {item.value}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid container item alignItems="center" xs={12} style={gridStyle}>
                    {" "}
                    {/* description */}
                    <TextField
                        required
                        fullWidth
                        margin={"none"}
                        label={getLocalizedString("kpiDescriptionText")}
                        value={formData.description}
                        onChange={(e) => setFormValue(e.target.value, "description")}
                        inputProps={{ maxLength: 254 }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* fecha desde publicacion */}
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateLocale}>
                        <DatePicker
                            style={{ marginTop: 8 }}
                            required
                            fullWidth
                            label={getLocalizedString("publicationDateFrom")}
                            cancelLabel={getLocalizedString("cancel")}
                            okLabel={getLocalizedString("ok")}
                            invalidDateMessage=""
                            format="dd/MM/yyyy"
                            margin="normal"
                            value={formData.tempStartDate}
                            onChange={(e) => setFormValue(e, "tempStartDate")}
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* fecha hasta publicacion */}
                    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={dateLocale}>
                        <DatePicker
                            style={{ marginTop: 8 }}
                            required
                            fullWidth
                            label={getLocalizedString("publicationEndDate")}
                            cancelLabel={getLocalizedString("cancel")}
                            okLabel={getLocalizedString("ok")}
                            invalidDateMessage=""
                            format="dd/MM/yyyy"
                            margin="normal"
                            value={formData.tempEndDate}
                            onChange={(e) => setFormValue(e, "tempEndDate")}
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
                <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                    {" "}
                    {/* role */}
                    <FormControl style={{ width: "100%" }}>
                        <InputLabel required id={`label-role`}>
                            {getLocalizedString("visualizationRol")}
                        </InputLabel>
                        <Select
                            value={formData.rol}
                            labelId={`label-role`}
                            id={`select-role`}
                            onChange={(e) => setFormValue(e.target.value, "rol")}
                            margin={"none"}
                        >
                            {roleTypes &&
                                roleTypes.map((item) => (
                                    <MenuItem className={"whiteText"} key={item.key} value={item.key}>
                                        {item.value}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}>
                    {" "}
                    {/* sql title */}
                    <TextFieldMultiline
                        fullWidth
                        label={getLocalizedString("sqlForKpiTitleRequiredForAllKpi")}
                        rows={8}
                        margin={"none"}
                        value={formData.sqlTitle}
                        onChange={(e) => setFormValue(e.target.value, "sqlTitle")}
                        inputProps={{ spellCheck: "false" }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}>
                    {" "}
                    {/* sql subtitle */}
                    <TextFieldMultiline
                        fullWidth
                        label={getLocalizedString("sqlForKpiSubtitle")}
                        rows={8}
                        margin={"none"}
                        value={formData.sqlSubtitle}
                        onChange={(e) => setFormValue(e.target.value, "sqlSubtitle")}
                        inputProps={{ spellCheck: "false" }}
                    />
                </Grid>

                {/* SQL Número BOX y CLOCK  */}
                {Boolean(isBoxType || isClockType) && (
                    <>
                        <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}>
                            {" "}
                            {/* sql para numero*/}
                            <TextFieldMultiline
                                fullWidth
                                label={getLocalizedString("sqlToDisplayNumberInBoxOrClock")}
                                rows={25}
                                margin={"none"}
                                value={formData.sqlNumber}
                                onChange={(e) => setFormValue(e.target.value, "sqlNumber")}
                                helperText={getLocalizedString(
                                    "withNumberValueRelatedIconWillBeShownInBoxOrNeedleInClock"
                                )}
                                inputProps={{ spellCheck: "false" }}
                            />
                        </Grid>
                    </>
                )}
                {Boolean(isClockType) && (
                    <>
                        <Grid container item alignItems="center" xs={12} sm={6} md={3} style={gridStyle}>
                            {" "}
                            {/* Valor desde Clock */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("valueFromClock")}
                                InputProps={{ inputComponent: CustomNumberFormat }}
                                value={formData.clockMinimumValue}
                                onChange={(e) => setFormValue(e.target.value, "clockMinimumValue")}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} sm={6} md={3} style={gridStyle}>
                            {" "}
                            {/* Valor hasta Clock */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("valueUntilClock")}
                                InputProps={{ inputComponent: CustomNumberFormat }}
                                value={formData.clockMaximumValue}
                                onChange={(e) => setFormValue(e.target.value, "clockMaximumValue")}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} sm={6} md={3} style={gridStyle}>
                            {" "}
                            {/* Valor desde Green */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("valueFromGreen")}
                                InputProps={{ inputComponent: CustomNumberFormat }}
                                value={formData.clockMinumumGreenValue}
                                onChange={(e) => setFormValue(e.target.value, "clockMinumumGreenValue")}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} sm={6} md={3} style={gridStyle}>
                            {" "}
                            {/* Valor hasta Green */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("valueUpToGreen")}
                                InputProps={{ inputComponent: CustomNumberFormat }}
                                value={formData.clockMaximumGreenValue}
                                onChange={(e) => setFormValue(e.target.value, "clockMaximumGreenValue")}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} sm={6} md={3} style={gridStyle}>
                            {" "}
                            {/* Valor desde Yellow */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("valueFromYellow")}
                                InputProps={{ inputComponent: CustomNumberFormat }}
                                value={formData.clockMinimumYellowValue}
                                onChange={(e) => setFormValue(e.target.value, "clockMinimumYellowValue")}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} sm={6} md={3} style={gridStyle}>
                            {" "}
                            {/* Valor hasta Yellow */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("valueUntilYellow")}
                                InputProps={{ inputComponent: CustomNumberFormat }}
                                value={formData.clockMaximumYellowValue}
                                onChange={(e) => setFormValue(e.target.value, "clockMaximumYellowValue")}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} sm={6} md={3} style={gridStyle}>
                            {" "}
                            {/* Valor desde Red */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("valueFromRed")}
                                InputProps={{ inputComponent: CustomNumberFormat }}
                                value={formData.clockMinimumRedValue}
                                onChange={(e) => setFormValue(e.target.value, "clockMinimumRedValue")}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} sm={6} md={3} style={gridStyle}>
                            {" "}
                            {/* Valor hasta Red */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("valueUntilRed")}
                                InputProps={{ inputComponent: CustomNumberFormat }}
                                value={formData.clockMaximumRedValue}
                                onChange={(e) => setFormValue(e.target.value, "clockMaximumRedValue")}
                            />
                        </Grid>
                    </>
                )}
                {Boolean(isBoxType) && (
                    <>
                        <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                            {" "}
                            {/* Icono 1 BOX */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("icon1Box")}
                                value={formData.icon1}
                                onChange={(e) => setFormValue(e.target.value, "icon1")}
                                inputProps={{ maxLength: 254 }}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                            {" "}
                            {/* Valor desde Icono 1 */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("valueFromIcon1")}
                                InputProps={{ inputComponent: CustomNumberFormat }}
                                value={formData.icon1MinimumValue}
                                onChange={(e) => setFormValue(e.target.value, "icon1MinimumValue")}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                            {" "}
                            {/* Valor hasta Icono 1 */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("valueUntilIcon1")}
                                InputProps={{ inputComponent: CustomNumberFormat }}
                                value={formData.icon1MaximumValue}
                                onChange={(e) => setFormValue(e.target.value, "icon1MaximumValue")}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                            {" "}
                            {/* Icono 2 BOX */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("icon2Box")}
                                value={formData.icon2}
                                onChange={(e) => setFormValue(e.target.value, "icon2")}
                                inputProps={{ maxLength: 254 }}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                            {" "}
                            {/* Valor desde Icono 2 */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("valueFromIcon2")}
                                InputProps={{ inputComponent: CustomNumberFormat }}
                                value={formData.icon2MinimumValue}
                                onChange={(e) => setFormValue(e.target.value, "icon2MinimumValue")}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                            {" "}
                            {/* Valor hasta Icono 2 */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("valueUntilIcon2")}
                                InputProps={{ inputComponent: CustomNumberFormat }}
                                value={formData.icon2MaximumValue}
                                onChange={(e) => setFormValue(e.target.value, "icon2MaximumValue")}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                            {" "}
                            {/* Icono 3 BOX */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("icon3Box")}
                                value={formData.icon3}
                                onChange={(e) => setFormValue(e.target.value, "icon3")}
                                inputProps={{ maxLength: 254 }}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                            {" "}
                            {/* Valor desde Icono 3 */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("valueFromIcon3")}
                                InputProps={{ inputComponent: CustomNumberFormat }}
                                value={formData.icon3MinimumValue}
                                onChange={(e) => setFormValue(e.target.value, "icon3MinimumValue")}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} sm={6} md={4} style={gridStyle}>
                            {" "}
                            {/* Valor hasta Icono 3 */}
                            <TextField
                                fullWidth
                                margin={"none"}
                                label={getLocalizedString("valueUpToIcon3")}
                                InputProps={{ inputComponent: CustomNumberFormat }}
                                value={formData.icon3MaximumValue}
                                onChange={(e) => setFormValue(e.target.value, "icon3MaximumValue")}
                            />
                        </Grid>
                    </>
                )}
                {/* FIN SQL Número BOX y CLOCK  */}

                {/* SQL para gráficos  */}
                {Boolean(isGraphicType) && (
                    <>
                        <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}>
                            {" "}
                            {/* sql para graficos */}
                            <TextFieldMultiline
                                fullWidth
                                label={getLocalizedString("sqlForChartsHorizontalVerticalPieLinePolarOrRadar")}
                                rows={25}
                                margin={"none"}
                                value={formData.sqlChart}
                                onChange={(e) => setFormValue(e.target.value, "sqlChart")}
                                helperText={getLocalizedString("kpiDefinitionGraphSQLHelper")}
                                inputProps={{ spellCheck: "false" }}
                            />
                        </Grid>
                    </>
                )}
                {/* FIN SQL para gráficos */}

                {/* SQL para detalle de gráficos*/}
                {Boolean(isDetailedGraphicType) && (
                    <>
                        <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}>
                            {" "}
                            {/* sql title */}
                            <TextFieldMultiline
                                fullWidth
                                label={getLocalizedString("sqlForLevel2GraphicsTitleOptional")}
                                rows={8}
                                margin={"none"}
                                value={formData.sqlTitleLevel2}
                                onChange={(e) => setFormValue(e.target.value, "sqlTitleLevel2")}
                                inputProps={{ spellCheck: "false" }}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}>
                            {" "}
                            {/* sql para graficos nivel 2*/}
                            <TextFieldMultiline
                                fullWidth
                                label={getLocalizedString("sqlForLevel2ChartsHorizontalVerticalPieOrLine")}
                                rows={25}
                                margin={"none"}
                                value={formData.sqlChartLevel2}
                                onChange={(e) => setFormValue(e.target.value, "sqlChartLevel2")}
                                helperText={getLocalizedString("forSQLChartsYouMustAlwaysSelect2Columns")}
                                inputProps={{ spellCheck: "false" }}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}>
                            {" "}
                            {/* sql title */}
                            <TextFieldMultiline
                                fullWidth
                                label={getLocalizedString("sqlForLevel3ChartTitleOptional")}
                                rows={8}
                                margin={"none"}
                                value={formData.sqlTitleLevel3}
                                onChange={(e) => setFormValue(e.target.value, "sqlTitleLevel3")}
                                inputProps={{ spellCheck: "false" }}
                            />
                        </Grid>
                        <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}>
                            {" "}
                            {/* sql para graficos nivel 2*/}
                            <TextFieldMultiline
                                fullWidth
                                label={getLocalizedString("sqlForLevel3ChartsHorizontalVerticalPieOrLine")}
                                rows={25}
                                margin={"none"}
                                value={formData.sqlChartLevel3}
                                onChange={(e) => setFormValue(e.target.value, "sqlChartLevel3")}
                                helperText={getLocalizedString("forSQLChartsYouMustAlwaysSelect2Columns")}
                                inputProps={{ spellCheck: "false" }}
                            />
                        </Grid>
                    </>
                )}
                {/* FIN SQL para detalle de gráficos*/}

                {/* SQL de visualización  */}
                <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}>
                    {" "}
                    {/* SQL de visualización */}
                    <TextFieldMultiline
                        fullWidth
                        label={getLocalizedString("viewSql")}
                        rows={25}
                        margin={"none"}
                        value={formData.sqlVisualization}
                        onChange={(e) => setFormValue(e.target.value, "sqlVisualization")}
                        helperText={getLocalizedString("optionalKpiSqlDescription")}
                        inputProps={{ spellCheck: "false" }}
                    />
                </Grid>
                <Grid container item alignItems="center" xs={12} style={{ padding: "0px 10px" }}>
                    {" "}
                    {/* selectores */}
                    <TextField
                        required={Boolean(formData.sqlVisualization)}
                        fullWidth
                        helperText={getLocalizedString(
                            "forEachSQLColumnSelectorTypesCanBeListDateAlphanumericNumericCurrency"
                        )}
                        margin={"none"}
                        label={getLocalizedString("columnSelectorForEachSQLColumnType")}
                        value={formData.selectors}
                        onChange={(e) => setFormValue(e.target.value, "selectors")}
                    />
                </Grid>
                <Grid
                    container
                    item
                    alignItems="center"
                    justify="center"
                    xs={12}
                    style={{ marginTop: 10, marginBottom: 20 }}
                >
                    <SelectorButton
                        text={getLocalizedString("dropdownList")}
                        onClick={() => setFormValue(`${formData.selectors},Lista`, "selectors")}
                    />
                    <SelectorButton
                        text={getLocalizedString("date")}
                        onClick={() => setFormValue(`${formData.selectors},Fecha`, "selectors")}
                    />
                    <SelectorButton
                        text={getLocalizedString("alphanumeric")}
                        onClick={() => setFormValue(`${formData.selectors},Alfa`, "selectors")}
                    />
                    <SelectorButton
                        text={getLocalizedString("integerNumeric")}
                        onClick={() => setFormValue(`${formData.selectors},Num`, "selectors")}
                    />
                    <SelectorButton
                        text={getLocalizedString("numericWithDecimals")}
                        onClick={() => setFormValue(`${formData.selectors},Mon`, "selectors")}
                    />
                </Grid>
                {/* FIN SQL de visualizacion */}
            </Grid>
            <Grid container item xs={12} justify={"flex-end"} alignItems="center" style={{ marginBottom: 35 }}>
                <ButtonDialogAction isAccept onClick={submit} text={getLocalizedString("save")} />
            </Grid>
        </Grid>
    );
};

export default QueryForm;
